import React, { useEffect, useState } from "react";
import { CacheProvider } from "@emotion/react";
import {
  Alert,
  CircularProgress,
  createTheme,
  Snackbar,
  Switch,
  ThemeProvider,
} from "@mui/material";
import MUIDataTable from "mui-datatables";
import createCache from "@emotion/cache";
import axios from "axios";
import Loader from "../componants/Loader";
const muiCache = createCache({
  key: "mui-datatables",
  prepend: true,
});

const CompanyStatus = () => {
  const [apiResponse, setApiResponse] = useState("");
  const [flag, setFlag] = useState(false);
  const [allData, setallData] = useState([]);
  const [changeStatus, setChangeStatus] = useState("");
  const [statusResponse, setStatusResponse] = useState("");
  const [open, setOpen] = useState(false);
  const [clicked, setClicked] = useState("");
  const [lodar, setLodar] = useState(false);

  useEffect(() => {
    if (changeStatus) {
      setFlag(true);
      if (changeStatus.status === "yes") {
        axios
          .get(`/deactivateentry/${changeStatus.password}`)
          .then((reponse) => {
            console.log(reponse);
            setStatusResponse(reponse);
            setOpen(true);

            // setFlag(false);
          });
      } else if (!changeStatus.status) {
        axios
          .get(`/activatesingleentry/${changeStatus.password}`)
          .then((reponse) => {
            console.log(reponse);
            setStatusResponse(reponse);
            setOpen(true);
            // setFlag(false);
          });
      }
    }
  }, [changeStatus]);
  useEffect(() => {
    setLodar(true);
    axios.get("/active_status_details").then((response) => {
      setApiResponse(response);
      setFlag(false);
      setLodar(false);
    });
  }, [statusResponse]);

  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  useEffect(() => {
    if (apiResponse.data) {
      console.log(apiResponse.data);
      const uniqueRows = [];
      const tableData = apiResponse.data.data.reduce((accumulator, row) => {
        const key = JSON.stringify(row);
        if (!uniqueRows.includes(key)) {
          uniqueRows.push(key);
          const rowData = [
            row.customer,
            row.email,
            row.product,
            row.username,
            row.activestatus,
            row.password,
          ];
          const isEmptyRow = rowData.every(
            (value) => value === null || value === undefined
          );
          if (!isEmptyRow && row.email !== null) {
            accumulator.push(rowData);
          }
        }
        return accumulator;
      }, []);
      const nonEmptyTableData = tableData.filter((row) =>
        row.some((value) => value !== null && value !== undefined)
      );
      setallData(nonEmptyTableData);
    }
  }, [apiResponse]);

  const options = {
    search: "true",
    download: "true",
    selectableRows: false,
    selectableRowsHeader: false,
    selectableRowsHideCheckboxes: true,
    print: "false",
    viewColumns: "true",
    filter: "true",
    filterType: "dropdown",
    responsive: "standard",
    tableBodyHeight: "auto",
    tableBodyMaxHeight: "600px",
  };
  const handleSwitchChange = (value, password) => {
    console.log(value, password);
    setChangeStatus({ status: value, password });
    setClicked(password);
  };

  const columns = [
    {
      name: "Company Name",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => <div>{value}</div>,
      },
    },
    {
      name: "Email",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => <div>{value}</div>,
      },
    },
    {
      name: "Product",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => <div>{value}</div>,
      },
    },
    {
      name: "",
      options: {
        filter: false,
        search: false,
        viewColumns: false,
        customBodyRender: (value, tableMeta, updateValue) => null,
      },
    },
    {
      name: "Status",
      options: {
        filter: false,
        viewColumns: false,
        customBodyRender: (value, tableMeta, updateValue) => (
          <div>
            {flag && clicked === tableMeta.rowData[5] ? (
              <CircularProgress />
            ) : (
              <Switch
                checked={value}
                color="primary"
                onChange={() => handleSwitchChange(value, tableMeta.rowData[5])}
              />
            )}
          </div>
        ),
      },
    },
    {
      name: "",
      options: {
        filter: false,
        search: false,
        viewColumns: false,
        customBodyRender: (value, tableMeta, updateValue) => null,
      },
    },
  ];
  if (lodar) {
    return <Loader />;
  }
  return (
    <>
      <CacheProvider value={muiCache}>
        <ThemeProvider theme={createTheme()}>
          <MUIDataTable
            title="Company Status"
            data={allData}
            columns={columns}
            options={options}
            sx={{ height: "100vh" }}
          />
        </ThemeProvider>
      </CacheProvider>

      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        sx={{
          background: "linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)",
          color: "white",
        }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={"success"}
          sx={{ width: "100%" }}
        >
          {statusResponse.data}
        </Alert>
      </Snackbar>
    </>
  );
};

export default CompanyStatus;
